import { usePopup } from 'app/hooks/utils/popup';
import { SymptomItem } from 'lib/models/searches/symptoms';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { IoMdStarOutline } from 'react-icons/io';
import { LuX } from 'react-icons/lu';
import { SearchQueryProps } from '../props';

/**
 * Props for a selected symptom item component.
 */
type SelectedSymptomListProps = {
  items: SymptomItem[];
  form: UseFormReturn<SearchQueryProps, any, undefined>;
};

/**
 * Props for a selected symptom item component.
 */
type SelectedSymptomListItemProps = {
  symptomItem: SymptomItem;
  form: UseFormReturn<SearchQueryProps, any, undefined>;
};

/**
 * List of selected symptoms (which may be highlighted).
 */
export const SelectedSymptomList: React.FC<SelectedSymptomListProps> = ({
  items,
  form
}) => {
  return (
    <ul>
      {items.map((item) => (
        <SelectedSymptomListItem key={item.symptom.id} symptomItem={item} form={form} />
      ))}
    </ul>
  );
};

/**
 * A selected symptom item in a list.
 */
export const SelectedSymptomListItem: React.FC<SelectedSymptomListItemProps> = ({
  symptomItem,
  form
}) => {
  // Enable popups support
  const { enqueuePopup } = usePopup();

  // Variables
  const symptom = symptomItem.symptom;
  const isHighlighted = symptomItem.isHighlighted;
  const synonyms =
    symptom.synonyms.length > 0 ? symptom.synonyms.join(', ') : undefined;

  return (
    <li className={isHighlighted ? 'highlighted' : ''}>
      <span className="selection-name" title={synonyms}>
        {symptom.name}
      </span>
      <button
        title={
          (isHighlighted ? 'Highlighted. ' : 'Not highlighted. ') +
          `When a ${symptom.type.labelLower} is highlighted, the search results hides diagnoses without this ${symptom.type.labelLower}.`
        }
        className={
          'button button-xs button-secondary' +
          (isHighlighted ? ' button-accent opacity-50' : ' opacity-50')
        }
        onClick={() => {
          const nextSymptoms = [...form.getValues().symptoms];
          const i = nextSymptoms.findIndex((item) => item.symptom.id === symptom.id);
          nextSymptoms[i] = new SymptomItem({
            symptom: symptom,
            isHighlighted: !isHighlighted
          });
          form.setValue('symptoms', nextSymptoms);
        }}
      >
        <IoMdStarOutline />
      </button>
      <button
        className="button button-xs button-secondary opacity-50"
        onClick={() => {
          const newList = [...form.getValues().symptoms].filter(
            (item) => item.symptom.id !== symptom.id
          );
          form.setValue('symptoms', newList);
        }}
        title={`Remove ${symptom.type.labelLower} from search`}
      >
        <LuX />
      </button>
    </li>
  );
};
